import * as React from 'react';
import { sortBasedOnList } from '../utils';

export type Table9b2Data = { [key: string]: Table9b2Row }
export type Table9b2Row = {
  nonMotorizedTranspDeviceKilledTotal: number;
  nonMotorizedTranspDeviceKilledM: number;
  nonMotorizedTranspDeviceKilledF: number;
  nonMotorizedTranspDeviceKilledU: number;
  nonMotorizedTranspDeviceInjuredTotalM: number;
  nonMotorizedTranspDeviceInjuredTotalF: number;
  nonMotorizedTranspDeviceInjuredTotalU: number;
  nonMotorizedTranspDeviceInjuredAM: number;
  nonMotorizedTranspDeviceInjuredAF: number;
  nonMotorizedTranspDeviceInjuredAU: number;
  nonMotorizedTranspDeviceInjuredBM: number;
  nonMotorizedTranspDeviceInjuredBF: number;
  nonMotorizedTranspDeviceInjuredBU: number;
  nonMotorizedTranspDeviceInjuredCM: number;
  nonMotorizedTranspDeviceInjuredCF: number;
  nonMotorizedTranspDeviceInjuredCU: number;
  otherNonMotoristKilledTotal: number;
  otherNonMotoristKilledM: number;
  otherNonMotoristKilledF: number;
  otherNonMotoristKilledU: number;
  otherNonMotoristInjuredTotalM: number;
  otherNonMotoristInjuredTotalF: number;
  otherNonMotoristInjuredTotalU: number;
  otherNonMotoristInjuredAM: number;
  otherNonMotoristInjuredAF: number;
  otherNonMotoristInjuredAU: number;
  otherNonMotoristInjuredBM: number;
  otherNonMotoristInjuredBF: number;
  otherNonMotoristInjuredBU: number;
  otherNonMotoristInjuredCM: number;
  otherNonMotoristInjuredCF: number;
  otherNonMotoristInjuredCU: number;
}
export interface ITable9bProps {
  data: any;
}

const sortOrder = [
  "14 and younger",
  "15",
  "16",
  "17",
  "18",
  "19",
  "20",
  "21",
  "22",
  "23",
  "24",
  "25-34",
  "35-44",
  "45-54",
  "55-64",
  "65-74",
  "75 and older",
  "Age not stated",
  "TOTALS",
];

export default class Table9bSummary extends React.Component<ITable9bProps> {

  public render() {
    return (
      <React.Fragment>
        {!this.props.data && (
          <p>Loading....</p>
        )}
        {this.props.data && (
          <table className="ss-table summaryTable1">
            <colgroup>
              <col style={{ width: '20%' }} />
            </colgroup>
            <thead>
              <tr>
                <th rowSpan={4} className="border-right-bold">
                  <div className="ss-table-header">
                    <span className="header-number" style={{ border: 'none' }}>9b2</span>
                    <div style={{ width: '3px', height: '80px', borderLeft: '3px solid black' }} />
                    <span className="header-text">AGE AND SEX OF CASUALTIES</span>
                  </div>
                </th>
                <th colSpan={13} className="border-right-bold">NON-MOTORIST TRANSPORT DEVICE</th>
                <th colSpan={13}>OTHER NON-MOTORIST</th>
              </tr>
              <tr>
                <th rowSpan={2} colSpan={4} className="border-right-bold">KILLED</th>
                <th colSpan={9} className="border-right-bold">INJURED</th>
                <th rowSpan={2} colSpan={4} className="border-right-bold">KILLED</th>
                <th colSpan={9}>INJURED</th>
              </tr>
              <tr>
                <th colSpan={3} className="border-right-bold">A *</th>
                <th colSpan={3} className="border-right-bold">B * </th>
                <th colSpan={3} className="border-right-bold">C * </th>
                <th colSpan={3} className="border-right-bold">A *</th>
                <th colSpan={3} className="border-right-bold">B * </th>
                <th colSpan={3}>C * </th>
              </tr>
              <tr>
                <th>Total</th>
                <th>M</th>
                <th>F</th>
                <th className="border-right-bold">U</th>

                <th>M</th>
                <th>F</th>
                <th className="border-right-bold">U</th>

                <th>M</th>
                <th>F</th>
                <th className="border-right-bold">U</th>

                <th>M</th>
                <th>F</th>
                <th className="border-right-bold">U</th>
                <th>Total</th>
                <th>M</th>
                <th>F</th>
                <th className="border-right-bold">U</th>

                <th>M</th>
                <th>F</th>
                <th className="border-right-bold">U</th>

                <th>M</th>
                <th>F</th>
                <th className="border-right-bold">U</th>

                <th>M</th>
                <th>F</th>
                <th>U</th>
              </tr>
            </thead>
            <tbody>
              {sortBasedOnList(this.props.data, sortOrder).map((key) =>
                <tr key={key} className={key === "TOTALS" ? "border-bold bold-text" : null}>
                  <td className="border-right-bold">{key}</td>
                  <td className="numberTotals">{this.props.data[key].nonMotorizedTranspDeviceKilledTotal}</td>
                  <td className="numberTotals">{this.props.data[key].nonMotorizedTranspDeviceKilledM}</td>
                  <td className="numberTotals">{this.props.data[key].nonMotorizedTranspDeviceKilledF}</td>
                  <td className="numberTotals border-right-bold">{this.props.data[key].nonMotorizedTranspDeviceKilledU}</td>
                  <td className="numberTotals">{this.props.data[key].nonMotorizedTranspDeviceInjuredAM}</td>
                  <td className="numberTotals">{this.props.data[key].nonMotorizedTranspDeviceInjuredAF}</td>
                  <td className="numberTotals border-right-bold">{this.props.data[key].nonMotorizedTranspDeviceInjuredAU}</td>
                  <td className="numberTotals">{this.props.data[key].nonMotorizedTranspDeviceInjuredBM}</td>
                  <td className="numberTotals">{this.props.data[key].nonMotorizedTranspDeviceInjuredBF}</td>
                  <td className="numberTotals border-right-bold">{this.props.data[key].nonMotorizedTranspDeviceInjuredBU}</td>
                  <td className="numberTotals">{this.props.data[key].nonMotorizedTranspDeviceInjuredCM}</td>
                  <td className="numberTotals">{this.props.data[key].nonMotorizedTranspDeviceInjuredCF}</td>
                  <td className="numberTotals border-right-bold">{this.props.data[key].nonMotorizedTranspDeviceInjuredCU}</td>
                  <td className="numberTotals">{this.props.data[key].otherNonMotoristKilledTotal}</td>
                  <td className="numberTotals">{this.props.data[key].otherNonMotoristKilledM}</td>
                  <td className="numberTotals">{this.props.data[key].otherNonMotoristKilledF}</td>
                  <td className="numberTotals border-right-bold">{this.props.data[key].otherNonMotoristKilledU}</td>
                  <td className="numberTotals">{this.props.data[key].otherNonMotoristInjuredAM}</td>
                  <td className="numberTotals">{this.props.data[key].otherNonMotoristInjuredAF}</td>
                  <td className="numberTotals border-right-bold">{this.props.data[key].otherNonMotoristInjuredAU}</td>
                  <td className="numberTotals">{this.props.data[key].otherNonMotoristInjuredBM}</td>
                  <td className="numberTotals">{this.props.data[key].otherNonMotoristInjuredBF}</td>
                  <td className="numberTotals border-right-bold">{this.props.data[key].otherNonMotoristInjuredBU}</td>
                  <td className="numberTotals">{this.props.data[key].otherNonMotoristInjuredCM}</td>
                  <td className="numberTotals">{this.props.data[key].otherNonMotoristInjuredCF}</td>
                  <td className="numberTotals">{this.props.data[key].otherNonMotoristInjuredCU}</td>
                </tr>
              )}
            </tbody>
          </table>
        )}
      </React.Fragment>
    );
  }
}
